import type { SecondDriverOptions } from '@yescapa-dev/ysc-api-js/legacy'
import { SECOND_DRIVER_STATES } from '@yescapa-dev/ysc-api-js/modern'

export const isSecondDriverActivated = (val?: SecondDriverOptions) => val === SECOND_DRIVER_STATES.SELECTED || val === SECOND_DRIVER_STATES.INCLUDED
